<template>
  <div class="group container">
    <div v-if="showTestButton">
      <EntryTest :step="1" />
    </div>
    <entry-index :step="1"></entry-index>
    <h3>送付先情報入力</h3>
    <information />
    <div class="alert alert-info">払込票･請求書のお届け先は学校住所に限定させていただきます。</div>
    <validation-observer v-slot="{ handleSubmit, validated, invalid }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="form-group col-12">
          <label class="h5" for="selKen">学校名</label> <span class="badge badge-danger">必須</span>
          <div class="form-row">
            <div class="col-6">
              <validation-provider rules="required" v-slot="{ errors }">
                <select class="custom-select d-block" :class="{ 'is-invalid': errors[0] }" id="selKen" v-model="$store.state.entry.ken">
                  <option v-for="item in $store.getters.kenList" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </validation-provider>
            </div>
            <div class="col-6">
              <validation-provider rules="required" v-slot="{ errors }">
                <select class="custom-select d-block" :class="{ 'is-invalid': errors[0] }" id="selFounder" v-model="$store.state.entry.schoolFounder">
                  <option v-for="item in $store.getters.schoolFounderList" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <validation-provider rules="sel-school:@useOtherSchoolName" v-slot="{ errors }">
                <select class="custom-select d-block" :class="{ 'is-invalid': errors[0] }" id="selSchool" v-model="$store.state.entry.schoolCode" :disabled="useOtherSchoolName">
                  <option v-for="item in $store.getters.schoolList" :key="item.code" :value="item.code">{{item.name}}</option>
                </select>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="form-group col-12" v-if="false">
          <div class="form-row">
            <div class="col-12">
              <div class="custom-control custom-checkbox">
                <validation-provider rules="" name="useOtherSchoolName">
                  <input id="chkOtherSchool" type="checkbox" class="custom-control-input" v-model="$store.state.entry.useOtherSchoolName">
                  <label class="custom-control-label" for="chkOtherSchool"> 上記の選択肢以外（学校名を入力してください。）</label>
                </validation-provider>
              </div>
              <div>
                <validation-provider rules="school-name:@useOtherSchoolName" v-slot="{ errors }">
                  <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtOtherSchool" v-model="$store.state.entry.otherSchoolName" :disabled="!useOtherSchoolName">
                  <div class="text-danger">{{ errors[0] }}</div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group col-12 mt-4">
          <label class="h5" for="txtZipCode">郵便番号（ハイフンなし）</label> <span class="badge badge-info" v-if="!useOtherSchoolName">自動補完</span><span class="badge badge-danger" v-else>必須</span>
          <div class="form-row">
            <div class="col-6">
              <validation-provider rules="zip-code" v-slot="{ errors }">
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtZipCode" v-model="$store.state.entry.zipCode" maxlength="7" :readonly="!useOtherSchoolName">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="form-group col-12">
          <label class="h5" for="txtAddress">学校住所</label> <span class="badge badge-info" v-if="!useOtherSchoolName">自動補完</span><span class="badge badge-danger" v-else>必須</span>
          <div class="form-row">
            <div class="col-12">
              <validation-provider rules="required" v-slot="{ errors }">
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtAddress" v-model="$store.state.entry.address" :readonly="!useOtherSchoolName">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="form-group col-12 mt-4">
          <label class="h5" for="txtTel1">電話番号</label> <span class="badge badge-danger">必須</span>
          <div class="form-row">
            <div class="col-3">
              <validation-provider rules="tel-number" v-slot="{ errors }">
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtTel1" v-model="$store.state.entry.tel1">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <span>ー</span>
            <div class="col-3">
              <validation-provider rules="tel-number" v-slot="{ errors }">
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtTel2" v-model="$store.state.entry.tel2">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <span>ー</span>
            <div class="col-3">
              <validation-provider rules="tel-number" v-slot="{ errors }">
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtTel3" v-model="$store.state.entry.tel3">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="form-group col-12 mt-4">
          <label class="h5" for="txtNameFamily">宛名（代表者）氏名</label> <span class="badge badge-danger">必須</span>
          <div class="form-row">
            <div class="col-6">
              <validation-provider rules="valid-name" v-slot="{ errors }">
                <label for="txtNameFamily">姓</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtNameFamily" placeholder="姓" v-model="$store.state.entry.teacherNameFamily">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <div class="col-6">
              <validation-provider rules="valid-name" v-slot="{ errors }">
                <label for="txtNameFirst">名</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtNameFirst" placeholder="名" v-model="$store.state.entry.teacherNameFirst">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
          <div class="form-row">
            <div class="col-6">
              <validation-provider rules="kana-only" v-slot="{ errors }">
                <label for="txtKanaFamily">姓＜全角カナ＞</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtKanaFamily" placeholder="姓＜全角カタカナ＞" v-model="$store.state.entry.teacherKanaFamily">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
            <div class="col-6">
              <validation-provider rules="kana-only" v-slot="{ errors }">
                <label for="txtKanaFirst">名＜全角カナ＞</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtKanaFirst" placeholder="名＜全角カタカナ＞" v-model="$store.state.entry.teacherKanaFirst">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="form-group col-12 mt-4">
          <label class="h5" for="txtMail">メールアドレス</label> <span class="badge badge-info" v-if="isMailReadOnly">変更不可</span><span class="badge badge-danger" v-else>必須</span>
          <div class="form-row">
            <div class="col-12">
              <p class="text-danger" v-if="!isMailReadOnly">※社内で受付入力を代行する場合､社内メールアドレス(@daiichi-g.co.jp)はSPAM判定され､メールアドレスが届きません｡</p>
              <validation-provider rules="required|email" vid="mail" v-slot="{ errors }">
                <input type="mail" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtMail" v-model="$store.state.entry.mail" :readonly="isMailReadOnly">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="form-group col-12 mt-4">
          <label class="h5" for="watchSubject">受講教科</label> <span class="badge badge-danger">必須</span>
          <p class="text-danger">
            ※一回の注文で一教科のみとなります｡複数教科の受講をご希望の場合はお手数ですが，申込を教科毎にお願いいたします｡
          </p>
          <div class="form-row">
            <div class="col-6">
              <validation-provider rules="required" v-slot="{ errors }">
                <select class="custom-select d-block" :class="{ 'is-invalid': errors[0] }" id="selSubject" v-model="$store.state.entry.subject">
                  <option v-for="i in $store.getters.subjectList" :key="i.code" :value="i.code">{{i.name}}</option>
                </select>
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="form-group col-12 mt-4">
            <div class="d-flex">
              <label class="h5" for="txtMail">お支払い</label>
              <div class="infoButton">
                <b-button size="sm" variant="primary" v-b-modal.modal-bill>詳細</b-button>
              </div>
            </div>
            <p class="text-danger">
              ※お支払いが弊社で確認出来たら，IDとパスワードをご登録していただいたメールアドレス宛に送信いたします｡
            </p>
          
          <div class="alert alert-info">
            お支払い合計額は <span class="h4">{{ $store.getters['entry/dispCharge']}}</span>円（税込）です。
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <label for="txtReceiptName">請求書宛名</label> <span class="badge badge-danger">必須</span>
              <validation-provider rules="required" v-slot="{ errors }">
                <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" id="txtReceiptName" :disabled="!isBill" v-model="$store.state.entry.receipt">
                <div class="text-danger">{{ errors[0] }}</div>
              </validation-provider>
            </div>
          </div>
        </div>
        <!-- ナビゲーションボタン -->
        <div class="form-row">
          <div class="col-6"></div>
          <div class="col-6">
            <button type="submit" class="btn btn-lg btn-secondary btn-block next_button">
              登録内容確認へ　<i class="fas fa-chevron-circle-right"></i>
            </button>
            <div class="text-danger" v-if="validated && invalid">入力項目をご確認ください。</div>
          </div>
        </div>
      </form>
    </validation-observer>

    <div>
      <b-modal id="modal-bill" size="xl" title="払込票によるお支払い" ok-only>
        <ul>
          <li>
            <span>ご入力いただいた学校住所宛てに「請求書」「払込票（振込用紙）」をお届けします。</span>
          </li>
          <li>
            <span>お受け取り後，払込票にて代金のお支払いをお願いいたします。</span><br />
            <span>払込票にてお支払いいただいた場合の手数料は弊社にて負担いたします。</span><br />
            <span>銀行振込によるお支払いの場合，振込手数料をご負担いただきます。</span>
          </li>
          <li>
            <span>お支払いが弊社で確認出来たら，IDとパスワードをご登録していただいたメールアドレス宛に送信いたします｡</span>
          </li>
        </ul>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Information from "@/components/Information.vue"
import EntryIndex from "@/components/EntryIndex.vue"
import EntryTest from "@/components/EntryTest.vue"
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { setInteractionMode } from 'vee-validate'
import { required, email, max } from  'vee-validate/dist/rules'

setInteractionMode('passive')

extend('required', {
  ...required,
  message: 'ご入力ください'
})
extend('email', {
  ...email,
  message: '不正なメールアドレス形式です'
})
extend('max', {
  ...max,
  message: '{_length_}文字まで入力可能です'
})
extend('zip-code', {
  computesRequired: true,
  validate: (value) => {
    return value.match(/^\d{7}$/)
  },
  message: '7桁の数値でご入力ください'
})
extend('tel-number', {
  computesRequired: true,
  validate: (value) => {
    return value.match(/^[０-９0-9]+$/)
  },
  message: '数値をご入力ください'
})
extend('valid-name', {
  computesRequired: true,
  validate: (value) => {
    return value.replace(/[ 　]/g,'') != '' && !value.match(/[,|&"<>]/)
  },
  message: 'ご入力ください（一部の記号は使用できません）'
})
extend('kana-only', {
  computesRequired: true,
  validate: (value) => {
    return value != '' && value.replace(/[ 　]/g,'').match(/^[ァ-ー]+$/)
  },
  message: '全角カナでご入力ください'
})
extend('sel-school', {
  computesRequired: true,
  params: ['useOtherSchoolName'],
  validate: (value, { useOtherSchoolName }) => {
    return useOtherSchoolName || value != ''
  }
})
extend('school-name', {
  computesRequired: true,
  params: ['useOtherSchoolName'],
  validate: (value, { useOtherSchoolName }) => {
    return !useOtherSchoolName || (value != '' && !value.match(/[&"<>]/))
  },
  message: 'ご入力ください（一部の記号は使用できません）'
})
extend('entrant-count', {
  validate: value => value > 0,
  message: '受講者が入力されていません。'
})
extend('receipt-name', {
  computesRequired: true,
  validate: (value) => {
    return !value.match(/[&"<>]/)
  },
  message: 'ご入力ください（一部の記号は使用できません）'
})
export default {
  name: "EntryStep1",
  data() {
    return {}
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Information,
    EntryIndex,
    EntryTest
  },
  computed: {
    zipCode() {
      return this.$store.state.entry.zipCode
    },
    schoolRefresh() {
      return [this.$store.state.entry.ken, this.$store.state.entry.schoolFounder]
    },
    schoolCode() {
      return this.$store.getters['entry/schoolCode']
    },
    schoolName() {
      return this.$store.getters['entry/schoolName']
    },
    useOtherSchoolName() {
      return this.$store.state.entry.useOtherSchoolName
    },
    isMailReadOnly() {
      return !this.$store.getters.isForceEntryMode
    },
    showTestButton() {
      return this.$store.state.showTestButton
    },
    entrantFirst() {
      return {
        nameFamily: this.$store.state.entry.teacherNameFamily,
        nameFirst:  this.$store.state.entry.teacherNameFirst,
        kanaFamily: this.$store.state.entry.teacherKanaFamily,
        kanaFirst:  this.$store.state.entry.teacherKanaFirst,
      };
    },
    isBill() {
      return this.$store.state.entry.payment == 'bill'
    },
  },
  watch: {
    zipCode(newVal) {
      if (!this.useOtherSchoolName) return
      if (newVal == '') {
        this.$store.dispatch('entry/clearAddress')
        return
      }
      new window.YubinBango.Core(newVal, (addr) => {
        console.log(addr)
        this.$store.dispatch('entry/setAddressFromZipCode', addr)
      })
    },
    schoolRefresh() {
      this.$store.dispatch('refreshSchoolList')
    },
    schoolCode(code) {
      this.$store.dispatch('entry/setAddressFromSchoolCode', { code })
    },
    schoolName(receipt) {
      this.$store.dispatch('entry/setFirstReceipt', { receipt })
    },
    useOtherSchoolName() {
      this.$store.dispatch('entry/clearSchoolCode')
    },
    entrantFirst(newVal) {
      this.$store.dispatch('entry/setFirstEntrant', newVal)
    }
  },
  mounted() {
    document.getElementById('html').scrollTop = 0
  },
  methods: {
    onSubmit() {
      this.$router.push('confirm')
    }
  }
}
</script>
